module.exports = __webpack_public_path__ + "img/badge_benefit_hub.287eb1a9.jpg";